import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import { Table } from 'src/components/ui';
import Icon from 'src/components/Icon';
import { StatusBadge } from './StatusBadge';
import { ScheduleStatusRow } from './useScheduleStatuses';

/** Schedules with their status; clicking a row opens that schedule. */
export function ScheduleLinkList({
  rows,
  onRowClick,
  heading,
  emptyMessage,
}: {
  rows: ScheduleStatusRow[];
  onRowClick: (row: ScheduleStatusRow) => void;
  heading?: ReactNode;
  emptyMessage?: ReactNode;
}) {
  return (
    <Table size="sm" className="mb-0 mt-3 pb-2">
      <thead>
        <tr>
          <th style={{ width: '60%' }}>{heading ?? <Trans>Schedule</Trans>}</th>
          <th className="text-center" style={{ width: '8rem' }}>
            <Trans>Status</Trans>
          </th>
          <th style={{ width: '2.5rem' }}></th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map(row => (
            <tr key={row.key ?? row.title} className="cursor-pointer transition-colors hover:bg-surface-2" onClick={() => onRowClick(row)}>
              <td className="small">{row.title}</td>
              <td className="text-center">
                <StatusBadge status={row.status} />
              </td>
              <td className="text-right pr-3 text-muted">
                <Icon icon="CaretRight" style={{ fontSize: '0.75rem' }} />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3} className="text-center text-muted small py-3">
              {emptyMessage ?? <Trans>No schedules configured</Trans>}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
